import {
  desktopContentMinWidthExclusive,
  mainPageContentBackgroundColor,
} from 'layouts/styles';

const listItemGap = 15;

export default theme => ({
  // Dashboard
  wrapper: {
    paddingTop: '20px',
    minWidth: desktopContentMinWidthExclusive,
    backgroundColor: mainPageContentBackgroundColor,
    '@media screen and (max-width: 600px)': {
      minWidth: 0,
    },
  },
  navigationRow: {
    paddingTop: 32,
    paddingBottom: 32,
    '@media screen and (max-width: 600px)': {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: '8px',
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  navigationCard: {
    width: 400,
    height: 72,
    borderRadius: 30,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 2,
    marginRight: 2,
    '@media screen and (max-width: 600px)': {
      width: 'auto',
      flex: '1 1 0',
      minWidth: 0,
      height: 'auto',
      marginLeft: 0,
      marginRight: 0,
      borderRadius: 16,
      '& .MuiCardActionArea-root': {
        minHeight: 68,
      },
      '& h6': {
        fontSize: '11px',
        lineHeight: '13px',
        fontWeight: 600,
      },
    },
  },
  mobileInset: {
    '@media screen and (max-width: 600px)': {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  organizationChart: {
    '@media screen and (max-width: 600px)': {
      marginBottom: 32,
    },
  },
  organizationCard: {
    '@media screen and (max-width: 600px)': {
      marginLeft: '0 !important',
      marginRight: '0 !important',
    },
  },
  organizationBody: {
    '@media screen and (max-width: 600px)': {
      padding: '32px 24px 40px !important',
    },
  },
  profilePane: {
    height: 347,
    marginLeft: 14,
    marginRight: 14,
    '@media screen and (max-width: 600px)': {
      height: 'auto',
      marginTop: 16,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  noDocumentsText: {
    marginTop: theme.spacing(2),
  },
  // BuyerDashboard
  listItem: {
    border: 'solid #F9A19A 1px',
    borderRadius: '4px',
    width: `calc(50% - ${listItemGap}px)`,
    '@media screen and (max-width: 600px)': {
      width: '100%',
    },
  },
  listItemIcon: {
    justifyContent: 'center',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${listItemGap}px`,
  },
  listItemGrey: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${listItemGap}px`,
    background: '#808080',
  },
  listItemTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginTop: '25px',
  },
  onBoardingGeneral: {
    background: '#ffffff',
    position: 'absolute',
    borderRadius: '4px',
  },
  switchContainer: {
    marginTop: '25px',
    padding: '0 10px 0',
  },
});
